var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};

(function ($) {
    var offers = $('#offers');
    var addSelectedButton = $('#btn-select');
    var selectedOffers = $('#selected-offers');
    var crudServiceBaseUrl = document.location.origin + '/api/DPN/OffersPerChannel/';
    var channelGroupForm = $('#channel-group-form');
    var channelSelector = channelGroupForm.find('select[name$="Channel"]');

    $.extend(MDB.DPN.Offers, {
        _channelGroupBatchId: '',
        _offersPerChannelGridConfig: null,
        
        bootChannelGroupSearch: function () {
            MDB.DPN.Offers._channelGroupBatchId = MDB.guid();
            
            channelSelector.on('change', function () {
                MDB.DPN.Offers._toggleReferencedDropdowns(this.value);
            });

            MDB.DPN.Offers._toggleReferencedDropdowns(channelSelector.val());
            
            MDB.DPN.Offers.bootSimpleSearch(function (config) {
                config.columns.unshift({
                    title: 'Selected',
                    template: MDB.KendoConfigBuilder.gridCheckboxTemplate('IsSelected', 'selected', false)
                });
            });

            MDB.DPN.Offers._loadGridConfiguration().then(function() {
                selectedOffers.kendoGrid(MDB.DPN.Offers._offersPerChannelGridConfig);
                
                //Our grid will be displaying 60+ columns - make our grid horizontally scrollable to accompany this
                selectedOffers.css('overflow-x', 'scroll');
                
                MDB.DPN.Offers._bindDataSourceSelectionChange();
                MDB.DPN.Offers._bindSubmitChannelOffersButtonClick();
                MDB.DPN.Offers._bindChannelOfferProductSelectionChange();
                MDB.DPN.Offers._bindChannelOfferWegenerCheckboxClick();
                MDB.DPN.Offers._bindAddSelectedOffersButtonClick();
            });
        },
        
        _toggleReferencedDropdowns: function (reference) {
            var referencedItems = $('.referenced');
            referencedItems.addClass('hidden');
            referencedItems.attr('disabled', 'disabled');
            
            var displayedItem = referencedItems.filter('[data-reference="' + reference  + '"]');
            
            displayedItem.removeClass('hidden');
            displayedItem.removeAttr('disabled');
        },
        
        _gridDisplayNameForTitle: function (title) {
            return title === 'AD' ? 'ADL' : title;
        },

        _bindDataSourceSelectionChange: function() {
            var dataSource = MDB.DPN.Offers._offersPerChannelGridConfig.dataSource;

            channelGroupForm.find('select').on('change', function () {
                dataSource.read().done(function() {
                    var pages = dataSource.totalPages();

                    if (pages < dataSource.page()) {
                        dataSource.page(pages);
                    }
                });
            });
        },
        
        _bindSubmitChannelOffersButtonClick: function() {
            channelGroupForm.find('.btn-form-submit').on('click', function(){
                //'Start' a new batch before syncing
                //BatchId will get added prior to the dataset prior to sending data to remote
                MDB.DPN.Offers._channelGroupBatchId = MDB.guid();

                MDB.DPN.Offers._offersPerChannelGridConfig.dataSource.sync().done(function() {
                    MDB.alert(MDB.loadResourceString('Offers_OffersPerChannel_Save_Success'));
                });
            });
        },

        _bindChannelOfferProductSelectionChange: function() {
            $(selectedOffers).on('click', '.product', function(){
                var $this = $(this)
                    , row = $this.closest('tr')
                    , rowId = row.data('uid')
                    , field = $this.data('field')
                    , sourceRow = MDB.DPN.Offers._offersPerChannelGridConfig.dataSource.getByUid(rowId);;

                var wegenerProducts = row.find('.wegener');
                var checkedProducts = wegenerProducts.filter(function () {
                    return this.checked;
                });

                var allWegenerTitlesChecked = checkedProducts.length === wegenerProducts.length;

                sourceRow[field] = this.checked;
                sourceRow['WEG'] = allWegenerTitlesChecked;
                sourceRow.dirty = true;

                row.find('[data-field="WEG"]').prop('checked', allWegenerTitlesChecked);

                //Kendo seems to replace arrays with its own object based wrapper
                //this wrapper also includes some type of reactiveness built into the push/splice methods
                //every modification seems to trigger an awfully slow repaint of our table
                //thus we overwrite our `SelectedProducts` property with a regular ol' JS array to prevent kendo from screwing us over
                sourceRow.SelectedProducts = _.toArray(sourceRow.SelectedProducts);
                
                //Mirror our selection change in our SelectedProducts field
                if(sourceRow[field]) {
                    sourceRow.SelectedProducts.push(field);
                } else {
                    sourceRow.SelectedProducts.splice(sourceRow.SelectedProducts.indexOf(field), 1);
                }
            });
        },

        _bindChannelOfferWegenerCheckboxClick: function() {
            $(selectedOffers).on('click', '.wegener-toggle', function (e) {
                var $this = $(this)
                    , row = $this.closest('tr');
                
                var checkedVal = this.checked;

                var wegenerProducts = row.find('.wegener');
                var selectedProducts = wegenerProducts.filter(function () {
                    return this.checked !== checkedVal;
                });

                if (selectedProducts.length === 0){
                    selectedProducts = wegenerProducts;
                }
                selectedProducts.each(function (){
                    $(this).trigger('click');
                });
            });
        },

        _bindAddSelectedOffersButtonClick: function() {
            var offersPerChannelDataSource = MDB.DPN.Offers._offersPerChannelGridConfig.dataSource;

            addSelectedButton.on('click', function(e){
                //Due to the button being located inside a form
                //We have to prevent the search form from submitting
                e.preventDefault();

                var offersDataSource = offers
                    .data('kendoGrid')
                    .dataSource;

                var rowProms = [];

                offers.find('tr').filter(function () {
                    return $(this).find('.selected').prop('checked') === true;
                })
                    .each(function () {
                        var modelId = this.getAttribute('data-uid');
                        var model = offersDataSource.getByUid(modelId);
                        var fields = offersPerChannelDataSource.options.schema.model.fields;

                        //Don't add duplicates
                        if (offersPerChannelDataSource.get(model.Prke)){
                            return;
                        }

                        Object.keys(fields).forEach(function(key){
                            //Ensure all fields are at least defined
                            if(model[key] === undefined) {
                                model[key] = undefined;
                            }
                        });

                        model['Channel'] = channelSelector.val();

                        var productsPerOfferProm = MDB.DPN.Offers.getPrkeProductsPerOffer(model.Prke);
                        rowProms.push(productsPerOfferProm);

                        productsPerOfferProm.done(function(records) {
                            model.EnabledProducts = _.uniq(_.map(records, 'Title'));
                            model.SelectedProducts = [];

                            model = offersPerChannelDataSource.add(model);
                            offersPerChannelDataSource.getByUid(model.uid).diry = true;
                        });
                    });

                if (rowProms.length) {
                    //All all rows should be added prior to potentially switching pages
                    $.when.apply($, rowProms).then(function() {
                        offersPerChannelDataSource.page(offersPerChannelDataSource.totalPages());
                    });
                }
            });
        },

        _loadGridConfiguration: function() {
            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function(opts) {
                        var url = crudServiceBaseUrl + 'GET?' + channelGroupForm.find('select').serialize().replace(/OffersPerChannelSearch\./g, '');
                        
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts).done(function () {
                            MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(MDB.DPN.Offers._offersPerChannelGridConfig);
                        });
                    },
                    update: function(opts){
                        opts.data.BatchId = MDB.DPN.Offers._channelGroupBatchId;

                        //Our PUT endpoint is a bit more picky about querystring parameters being present than our GET endpoint
                        //therefore we need to ensure all known querystring parameters are present
                        var queryParameters = channelGroupForm.find('select').serializeArray();
                        if(!queryParameters.some(function(parameter) { return parameter.name.includes('Exception') })) {
                            queryParameters.push({ name: 'Exception', value: undefined });
                        }
                        
                        var url = crudServiceBaseUrl + 'PUT?' + $.param(queryParameters).replace(/OffersPerChannelSearch\./g, '');
                        
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'PUT', opts);
                    }
                },
                pageSize: 20,
                schema: {
                    model: {
                        id: 'Prke',
                        fields: {
                            BatchId: {},
                            Prke: {type: 'number'},
                            Description: {},
                            Premium: {},
                            Duration: {type: 'number'},
                            DurationUnit: { },
                            Discount: {type: 'number'},
                            Price: {type: 'number'},
                            OfferType: {},
                            Channel: {}
                        }
                    }
                }
            });
            
            var gridConfig = {
                dataSource: dataSource,
                pageable: true,
                autoBind: true,
                columns: [
                    {
                        field: 'Prke',
                        title: 'Prke'
                    },{
                        field: 'Description',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Description_DisplayName')
                    },{
                        field: 'Premium' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Premium_DisplayName')
                    },{
                        field: 'Duration',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Duration_DisplayName')
                    },{
                        field: 'DurationUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_DurationUnit_Header')
                    },{
                        field: 'Price' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Price_DisplayName'),
                        format: '€ {0:n2}'
                    },{
                        field: 'PriceUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_PriceUnit_Header')
                    }, {
                        field: 'Discount' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Discount_DisplayName'),
                        format: '{0:p}'
                    },{
                        field: 'OfferType' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_OfferType_DisplayName')
                    },{
                        field: 'Channel' ,
                        title: 'Kanaal'
                    }
                ],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                // width: '500px',
                scrollable: false,
                editable: {
                    mode: 'inline'
                }
            };

            return $.ajax(crudServiceBaseUrl + 'Products').then(function(productNames) {
                var wegenerTitles = MDB.DPN.Offers.getTitles('p5');
                
                var firstWegenerTitleIndx = productNames.findIndex(function(productName) {
                    return wegenerTitles.includes(productName);
                });
                
                //Add a 'WEG' toggle before the first encountered wegener title
                productNames.splice(firstWegenerTitleIndx, 0, 'WEG');

                productNames.forEach(productName => {
                    var htmlClass = 'product';

                    // var isAd = adTitles.indexOf(t) !== -1;
                    var isWegenerToggle = productName === 'WEG';

                    if (wegenerTitles.indexOf(productName) !== -1){
                        htmlClass += ' wegener';
                    }

                    if (isWegenerToggle){
                        htmlClass = 'wegener-toggle';
                    }

                    gridConfig.dataSource.options.schema.model.fields[productName] = {type: 'boolean'};
                    gridConfig.columns.push({
                        field: productName,
                        template: function (model) {
                            //For regular titles, check if title is enabled
                            //For ADR/ADL, check if AD is enabled
                            //For WEG toggle, check if any WEG product is enabled
                            var checkedProducts = [productName];
                            // if (isAd) checkedProducts = checkedProducts.concat(adTitles);
                            if (isWegenerToggle) {
                                // debugger;
                                checkedProducts = checkedProducts.concat(wegenerTitles);
                                
                                //Pre-select wegener toggle when all wegener titles have been selected
                                model[productName] = wegenerTitles.every(function(wegenerProductName){ 
                                    return _.includes(model.SelectedProducts, wegenerProductName); 
                                });
                            }

                            //Don't automatically disable an already enabled checkbox
                            var isEnabled = model[productName] || _.intersection(model.EnabledProducts, checkedProducts).length !== 0;

                            //Non-enabled products are not available on our model by default
                            //ensure we have a matching property for Kendo not to crash upon attempting to use it in our checkbox template
                            model[productName] = model[productName] || _.includes(model.SelectedProducts, productName);
                            
                            return kendo.template(MDB.KendoConfigBuilder.gridCheckboxTemplate(productName, htmlClass, !isEnabled))(model);
                        },
                        title: MDB.DPN.Offers._gridDisplayNameForTitle(productName)
                    });
                });

                MDB.DPN.Offers._offersPerChannelGridConfig = gridConfig;
            });
        },
    });
})(jQuery);